module.exports = __webpack_public_path__ + "static/media/menu-options.f79ba89e.svg";